export default "__VITE_ASSET__zyLbcJyO__"